import { Entities, TOMCAT_URL } from 'src/common';
import { apiRequest } from 'src/actions/api/api';

export function fetchNewNotificationsSinceLastLogin() {
    return dispatch => {
        return dispatch(
            apiRequest({
                endpoint: `${TOMCAT_URL}api/${
                    Entities.RECENT_OPERATOR_NOTIFICATIONS.repository
                }/getNewNotificationsSinceLastLogin`,
                method: 'GET',
                secondaryActionTypes: [
                    `REQUEST_${Entities.RECENT_OPERATOR_NOTIFICATIONS.action}`,
                    `SUCCESS_${Entities.RECENT_OPERATOR_NOTIFICATIONS.action}`,
                    `FAILURE_${Entities.RECENT_OPERATOR_NOTIFICATIONS.action}`,
                ],
                reducerIndex: 0,
                schema: Entities.RECENT_OPERATOR_NOTIFICATIONS.schema,
            }),
        );
    };
}

export function operatorNotificationSendTestEmail(email, operatorNotification) {
    return dispatch => {
        return dispatch(
            apiRequest({
                endpoint: `${TOMCAT_URL}api/${Entities.RECENT_OPERATOR_NOTIFICATIONS.repository}/sendTestMail`,
                method: 'POST',
                body: JSON.stringify({
                    email,
                    operatorNotification,
                }),
                secondaryActionTypes: [
                    `REQUEST_${Entities.RECENT_OPERATOR_NOTIFICATIONS.action}`,
                    `SUCCESS_${Entities.RECENT_OPERATOR_NOTIFICATIONS.action}`,
                    `FAILURE_${Entities.RECENT_OPERATOR_NOTIFICATIONS.action}`,
                ],
                reducerIndex: 'Admin',
                schema: Entities.RECENT_OPERATOR_NOTIFICATIONS.schema,
            }),
        );
    };
}

export function operatorNotificationSendNewsletterEmails(operatorNotification) {
    return dispatch => {
        return dispatch(
            apiRequest({
                endpoint: `${TOMCAT_URL}api/${
                    Entities.RECENT_OPERATOR_NOTIFICATIONS.repository
                }/sendNewsletterNotifications`,
                method: 'POST',
                body: JSON.stringify({
                    email: '',
                    operatorNotification,
                }),
                secondaryActionTypes: [
                    `REQUEST_${Entities.RECENT_OPERATOR_NOTIFICATIONS.action}`,
                    `SUCCESS_${Entities.RECENT_OPERATOR_NOTIFICATIONS.action}`,
                    `FAILURE_${Entities.RECENT_OPERATOR_NOTIFICATIONS.action}`,
                ],
                reducerIndex: 0,
                schema: Entities.RECENT_OPERATOR_NOTIFICATIONS.schema,
            }),
        );
    };
}
